import { Config } from "./config";
export const WOH_AM_I_DATA = "WOH_AM_I_DATA";
export const USER_LOGIN_DATA = "USER_LOGIN_DATA";

// ---------authentication URL
export const whoamiUrl = `${Config.baseURL}whoami`;
export const loginURL = `${Config.baseURL}Identity/SignInWithUsernameAndPassword`;
export const changePasswordURL = `${Config.baseURL}Identity/ChangePassword`;

export const salutationListAPI = `${Config.baseURL}Salutation/List`;

//--------------------------------IDENTITY URLs-------------------------------------
//----------------------------------User URL-------------------------------------
export const getUserPagingAPI = `${Config.baseURL}Identity/Paging`;
export const createUserAPI = `${Config.baseURL}Identity/Create`;
export const userGetByIdAPI = (id: any) => {
  return `${Config.baseURL}Identity/${id}/GetById`;
};
export const userGet = (id: any) => {
  return `${Config.baseURL}Identity/${id}/Get`;
};
export const updateUsersAPI = (id: any) => {
  return `${Config.baseURL}Identity/${id}/Update`;
};
export const changeUsersStatusAPI = (id: any) => {
  return `${Config.baseURL}Identity/${id}/ChangeActiveStatus`;
};
//------------------------------User Mapping URL----------------------------------
export const getUserApplicationMappingPagingAPI = `${Config.baseURL}Identity/Applications`;
export const createUserApplicationMappingAPI = `${Config.baseURL}IdentityApplicationMapping/Create`;
export const userNotInApplicationAPI = `${Config.baseURL}Identity/NotInApplications`;
export const userRoleMappingPagingAPI = `${Config.baseURL}Identity/Roles`;
export const userNotInRolesAPI = `${Config.baseURL}Identity/NotInRoles`;
export const createRoleIdentityMappingAPI = `${Config.baseURL}RoleIdentityMapping/Create`;
export const deleteUserApplicationMappingAPI = `${Config.baseURL}Application/DeleteIdentityApplication`;

//---------------------------------Role URl---------------------------------------
export const getRolePagingAPI = `${Config.baseURL}Role/Paging`;
export const RoleGetByIdAPI = (id: any) => {
  return `${Config.baseURL}Role/${id}/Get`;
};
export const creteRoleAPI = `${Config.baseURL}Role/Create`;
export const applicationListAPI = `${Config.baseURL}Application/List`;
export const UpdateRoleAPI = (id: any) => {
  return `${Config.baseURL}Role/${id}/Update`;
};
export const deleteRoleAPI = `${Config.baseURL}Role/DeleteRole`;
//------------------------------Role Mapping URL-----------------------------------------
export const getRoleUserMappingAPI = `${Config.baseURL}Role/Users`;
export const createRolUserMappingAPI = `${Config.baseURL}RoleIdentityMapping/CreateRoleIdentity`;
export const getRoleNotInUsersAPI = `${Config.baseURL}Role/NotInUsers`;
export const getRoleApplicationMappingAPI = `${Config.baseURL}Role/Applications`;
export const getRoleNotInApplicationsAPI = `${Config.baseURL}Role/NotInApplications`;
export const createRolApplicationMappingAPI = `${Config.baseURL}RoleApplicationMapping/Create`;
export const getMenuByRoleIdAPI = `${Config.baseURL}RoleModule/GetMenusByRoleId`;
export const createRoleModulesAPI = `${Config.baseURL}RoleModule/Create`;
export const getRoleModulesMappingAPI = `${Config.baseURL}Role/Modules`;
export const getRoleNotInFeaturesAPI = `${Config.baseURL}Role/NotInFeatures`;
//export const deleteRolApplicationMappingAPI = `${Config.baseURL}RoleApplicationMapping/DeleteRoleApplicationMapping`;
export const deleteRoleUserMappingAPI = `${Config.baseURL}Role/DeleteRoleIdentity`;
export const deleteRoleApplicationMappingAPI = `${Config.baseURL}Role/DeleteRoleApplicationMapping`;
export const deleteRoleModuleMappingAPI = `${Config.baseURL}Role/DeleteRoleModule`;
export const deleteRoleFeatureMappingAPI = `${Config.baseURL}Role/DeleteRoleFeature`;

//---------------------------------Modules URL-----------------------------------------
export const modulesPagingAPI = `${Config.baseURL}Module/Paging`;
export const createModulesAPI = `${Config.baseURL}Module/Create`;
export const moduleGetByIdAPI = (id: any) => {
  return `${Config.baseURL}Module/${id}/Get`;
};
export const modulesListAPI = `${Config.baseURL}Module/List`;

export const updateModulesAPI = (id: any) => {
  return `${Config.baseURL}Module/${id}/Update`;
};
export const deleteModulesAPI = `${Config.baseURL}Module/DeleteModule`;
export const getModuleTreeAPI = `${Config.baseURL}RoleModule/GetModuleMenubyRoleId`

//------------------------------Modules Mapping URL--------------------------------
export const modulesMenuMappingAPI = `${Config.baseURL}Menu/GetMenusByModuleId`;

//-----------------------------------Menu URL-------------------------------------
export const menuPagingAPI = `${Config.baseURL}Menu/Paging`;
export const creteMenuAPI = `${Config.baseURL}Menu/Create`;
export const menuGetByIdAPI = (id: any) => {
  return `${Config.baseURL}Menu/${id}/Get`;
};
export const updateMenuAPI = (id: any) => {
  return `${Config.baseURL}Menu/${id}/Update`;
};
export const menuListAPI = `${Config.baseURL}Menu/List`;

//---------------------------------Feature URL------------------------------------
export const featurePagingAPI = `${Config.baseURL}Feature/Paging`;
export const creteFeatureAPI = `${Config.baseURL}Feature/Create`;
export const featureGetByIdAPI = (id: any) => {
  return `${Config.baseURL}Feature/${id}/Get`;
};
export const updateFeatureAPI = (id: any) => {
  return `${Config.baseURL}Feature/${id}/Update`;
};
export const roleFeaturePagingAPI = `${Config.baseURL}Role/Features`;
export const roleFeatureCreateAPI = `${Config.baseURL}RoleFeature/Create`;



//------------------------------Menu Mapping URL----------------------------
export const featureMenuPagingAPI = `${Config.baseURL}Feature/FeaturePaging`;
export const roleMenuMappingAPI = `${Config.baseURL}Menu/Roles`;
export const createMenuRoleMappingAPI = `${Config.baseURL}RoleModule/CreateByMenuId`;
export const menuNotInRolesAPI = `${Config.baseURL}Menu/NotInRoles`;
export const menuGroupListAPI = `${Config.baseURL}MenuGroup/List`;
export const deleteMenuAPI = `${Config.baseURL}Menu/DeleteMenu`;

//----------------------------Features Mapping URL--------------------------
export const featureRolesMappingAPI = `${Config.baseURL}Feature/Roles`;
export const featureNotInRolesAPI = `${Config.baseURL}Feature/NotInRoles`;
export const featureRoleListAPI = `${Config.baseURL}Menu/GetMenusByModuleId`;
export const createFeatureRoleMappingAPI = `${Config.baseURL}RoleFeature/CreateRolesByFeatureId`;
export const deleteFeatureRoleMappingAPI = `${Config.baseURL}RoleFeature/DeleteRoleFeature`;
export const featureAccessByFeatureIdAPI = `${Config.baseURL}FeatureAccess/ByFeatureId`;
export const deleteFeatureAPI = `${Config.baseURL}Feature/DeleteFeature`;


//-----------------------------Feature Access Url---------------------------
export const featureAccessPagingAPI = `${Config.baseURL}FeatureAccess/Paging`;
export const featureListAPI = `${Config.baseURL}Feature/List`;
export const featureAccessCreateAPI = `${Config.baseURL}FeatureAccess/Create`;
export const featureAccessGetByIdAPI = (id: any) => {
  return `${Config.baseURL}FeatureAccess/${id}/Get`;
};
export const featureAccessUpdateAPI = (id: any) => {
  return `${Config.baseURL}FeatureAccess/${id}/Update`;
};

export const deleteFeatureAccessAPI = `${Config.baseURL}FeatureAccess/DeleteFeatureAccess`;

//-------------------------------Menu Group Url-----------------------------
export const createMenuGroupAPI = `${Config.baseURL}MenuGroup/Create`;
export const menuGroupPagingAPI = `${Config.baseURL}MenuGroup/Paging`;
export const menuGroupGetByIdAPI = (id: any) => {
  return `${Config.baseURL}MenuGroup/${id}/Get`;
};
export const updateMenuGroupAPI = (id: any) => {
  return `${Config.baseURL}MenuGroup/${id}/Update`;
};

export const deleteMenuGroupAPI = (id: any) => {
  return `${Config.baseURL}MenuGroup/${id}/DeleteMenuGroup`;
};